module.exports = __webpack_public_path__ + "static/media/jackson.dbde9451.jpg";